module.exports = __webpack_public_path__ + "static/media/proceso_de_marketing_y_promoción.46a9965b.jpg";